import * as React from 'react';

import useEffectivePortableMode from '../../hooks/useEffectivePortableMode';

import FullScreenStats from './containers/FullScreenStats/FullScreenStats';
import PortableLayout from './containers/PortableLayout/PortableLayout';

import { useAuth } from '../../hooks/useAuth';

const StatPage = React.memo(() => {
  useAuth();

  const usePortableLayout = useEffectivePortableMode();

  if (usePortableLayout) {
    return <PortableLayout />;
  }

  return <FullScreenStats />;
});

export default StatPage;
